import FactureAvoirInitController from './facture.avoir.init.controller';

export default {
    bindings: {
        modalInstance: '=',
        idFactures: '=',
        dateFacture: '='
    },
    template: require('./facture.avoir.init.html'),
    controller: FactureAvoirInitController
};
